import { writable } from 'svelte/store';
function createAppState() {
    const { subscribe, set, update } = writable({
        file: null,
        fileId: null,
        metadata: {},
        nexusResult: null,
        loading: false,
        error: null
    });
    return {
        subscribe,
        setFile: (file) => update(state => (Object.assign(Object.assign({}, state), { file, fileId: null, metadata: {}, nexusResult: null, error: null }))),
        setLoading: (loading) => update(state => (Object.assign(Object.assign({}, state), { loading }))),
        setError: (error) => update(state => (Object.assign(Object.assign({}, state), { error }))),
        setFileId: (fileId) => update(state => (Object.assign(Object.assign({}, state), { fileId }))),
        setMetadata: (metadata) => update(state => (Object.assign(Object.assign({}, state), { metadata }))),
        setNexusResult: (result) => update(state => (Object.assign(Object.assign({}, state), { nexusResult: result }))),
        reset: () => set({
            file: null,
            fileId: null,
            metadata: {},
            nexusResult: null,
            loading: false,
            error: null
        })
    };
}
export const appState = createAppState();
